import React from 'react';

import os from '../assets/images/one-story/one-story.png';

const OneStory = ({ isVisible }) => {
    const animation = isVisible ? 'animated-1' : '';
    const animation1 = isVisible ? 'animated-3' : '';
    const animation2 = isVisible ? 'animated-4' : '';

    return (
      <div className="portfolio container">
        <div className="showcase_wrap">
          <div className="project">
            <img src={os} className={"mobile-img no-opacity " + animation} alt="One Life Story A Day" />
          </div>
          <div className="project_bg">
            <svg viewBox="0 0 1900 1900" className={"svg_bg no-opacity " + animation2} xmlns="http://www.w3.org/2000/svg">
              <path d="M1763.27064,1303.42896 C1567.99268,1621.80043 1149.04117,1823.48793 776.639829,1769.18745 C443.030293,1714.88697 16.3204197,1575.25716 24.078781,1164.12496 C24.078781,1094.31005 0.803697038,1024.49515 0.803697038,962.437457 C-8.06410996,749.664904 56.5397648,516.638272 190.262881,344.397149 C206.974391,322.86313 224.772072,302.283248 243.640406,282.812647 C512.855544,-46.0000326 1024.90739,-77.0288784 1374.03365,132.415831 C1668.85138,310.831695 1955.91075,628.877365 1836.10614,1000.49434 C1829.79859,1025.91472 1826.43146,1052.52971 1822.64538,1079.19125 C1815.09649,1132.50656 1803.55205,1184.71259 1788.73358,1234.46735 C1781.43296,1257.60711 1773.13927,1280.70809 1763.27064,1303.42896" fill="#e14444">
              </path>
            </svg>
          </div>
        </div>
        <div className={"showcase_desc no-opacity " + animation1}>
          <h2>One life story a day</h2>
          <p>Read one life story a day from people like you. Find out what people write for their personal journals and get inspired to write your own.</p>
          <h3><a href="https://itunes.apple.com/us/app/one-life-story-a-day/id1313623849?mt=8" target="_blank" rel="noopener noreferrer" id="one_story_ios">iOS</a> & <a href="https://play.google.com/store/apps/details?id=com.gnjstory.gnjstory" target="_blank" rel="noopener noreferrer" id="one_story_android">Android</a></h3>
          <p className="my-role">My Role: Founder, Design & Development</p>
          <p><a className="cta-btn" href="https://onestory.goodnightjournal.com/" target="_blank" rel="noopener noreferrer" id="one_story_more_cta">View page</a></p>
        </div>
      </div>
    )
}

export default OneStory



// WEBPACK FOOTER //
// ./src/components/OneStory.js